import { toValue, type MaybeRefOrGetter } from '@vueuse/core';
import { useUpcPreselect } from '~/modules/upc/composables/useUpcPreselect';
import type { GIFT_CARD_FIELDS } from '../../types';

export const useGiftConsolidatedPreselect = (
  values: Partial<Record<GIFT_CARD_FIELDS, string>>,
  selectedGift: MaybeRefOrGetter<null | number | string>,
) => {
  useUpcPreselect();
  const value = toValue(selectedGift);
  values.giftCardAmount = value === null ? '' : value.toString();
};
